import Forecast from './forecast';
import HeaderAlerts from '../headerAlerts';
import LayoutCheckbox from '../forms/layoutCheckbox';
import LayoutSelect from '../forms/layoutSelect';
import Medusa from 'medusajs';
import Modal from './modal';
import PropTypes from 'prop-types';
import React from 'react';
import events from 'lib/events';
import session from 'services/sessionService';
import {languages, allowTranslations} from 'helpers/languageHelper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

class NavBar extends React.Component {
  static propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string,
    }),
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    let branches = session.getMyBranches();

    this.state = {
      accountShow: false,
      showBranchesModal: false,
      selectedBranch: branches.length > 0 ? branches[0].id : null,
    };
  }

  componentDidMount() {
    let user = session.getUser();
    let apps = user.apps || [];

    window.insertAppSelector(window.idmAddress, apps, window.appName, null, null, false, true, this.props.intl.locale);

    this.unsub = events.subscribe('locale.changed', () => setTimeout(() => {
      let user = session.getUser();
      let apps = user.apps || [];

      document.querySelector('#app-select').innerHTML = '';

      window.insertAppSelector(window.idmAddress, apps, window.appName, null, null, false, true, this.props.intl.locale);
    }, 0));
  }

  componentWillUnmount() {
    if (this._eventHideAccountActivate) {
      clearTimeout(this._eventHideAccountActivate);
    }
    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }

    if (this.unsub && this.unsub.remove) {
      this.unsub.remove();
    }
  }

  _eventHideAccount = null;
  _eventHideAccountActivate = null;

  accountOptionsHide = (e) => {

    this.setState({accountShow: false});

    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }

  };

  accountOptionsShow = (e) => {
    e.preventDefault();

    this.setState({accountShow: true});

    if (this._eventHideAccount) {
      this._eventHideAccount.remove();
    }

    let self = this;

    this._eventHideAccountActivate = setTimeout(() => {
      self._eventHideAccount = events.subscribe('click', self.accountOptionsHide);
    }, 10);
  };

  closeBranchModal = () => {
    this.setState({
      showBranchesModal: false,
    });
  };

  downgrade = () => {
    let user = session.getUser();
    let branches = user.privileges.branches || [];

    if (branches.length === 0) {
      branches = session.getMyBranches() || [];
    }
    if (branches.length > 0) {
      this.openBranchModal();
    } else {
      session.downgrade();
    }
  };

  downgradeToBranch = (branchID) => {
    return () => {
      session.downgrade(branchID);
      this.closeBranchModal();
    };
  };

  logout = (e) => {
    e.preventDefault();

    if (window.keepAliveTimeout) {
      clearTimeout(window.keepAliveTimeout);
    }

    if (window.keepAliveInterval) {
      clearInterval(window.keepAliveInterval);
    }

    session.invalidateSession();
    session.nuke();
    Medusa.clear(); // NOTE: this clears all of localStorage not just the keys set in medusa

    console.log('nuking localstorage');

    window.location.href = '/Login/Logout';
  };

  openBranchModal = () => {
    this.setState({
      showBranchesModal: true,
    });
  };

  selectBranch = (e) => {
    this.setState({
      selectedBranch: e.value,
    });
  };

  toggleTitrationTestMode = (e) => {
    session.toggleTitrationTestMode();
  };

  toggleTitrationTestModeClickMenuItem = (e) => {
    e.preventDefault();
    e.stopPropagation();
    session.toggleTitrationTestMode();
    this.setState({accountShow: false});
  };

  handleOnClick = (e, condition, method) => {
    if (condition) {
      method(e);
    }

  };

  render() {
    let accountOptions;

    let user = session.getUser();
    let canDowngrade = !user.downgraded && user.privileges.level > 1000;
    let canUpgrade = user.downgraded && user.privileges.level === 1000;
    let languageItems = [];
    let locale = this.props.intl.locale;

    Object.keys(languages).forEach((key) => {
      languageItems.push(
        <a onClick={() => events.publish('set.language', key)}>
          <LayoutCheckbox label={<FormattedMessage id={languages[key].label}/>}
                          dataKey={'language-' + key}
                          key={'language-' + key}
                          value={key === locale}/>
        </a>
      );
    });

    if (this.state.accountShow) {

      let leftdd = document.getElementById('logout-dropdownleft');
      let getOffset = el => {
        let _x = 0;
        let _y = 0;

        while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
          _x += el.offsetLeft - el.scrollLeft;
          _y += el.offsetTop - el.scrollTop;
          el = el.offsetParent;
        }
        return {top: _y, left: _x};
      };

      let accountStyle = {
        display: 'block',
        width: '260px',
        top: '62px',
        left: getOffset(leftdd).left - 230,
      };

      accountOptions = <div className='popover bottom fade in'
                            style={accountStyle}>
        <div className='arrow'
             style={{left: '85%'}}/>
        <div className='popover-content account'>
          <div className='welcome-menu-item'>
            <a onClick={(e) => this.handleOnClick(e, canDowngrade, this.downgrade)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.test.station.mode'/>}
                              dataKey='canDowngrade'
                              key='canDowngrade'
                              value={!canDowngrade}/>
            </a>
            {canUpgrade ? <a onClick={(e) => this.handleOnClick(e, canUpgrade, this.logout)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.admin.mode'/>}
                              dataKey='canUpgrade'
                              key='canUpgrade'
                              value={!canUpgrade}/>
            </a> : null}
          </div>
          {allowTranslations ?
            <div className='welcome-menu-item'>
              {languageItems}
            </div> : null}
          <div className='welcome-menu-item'>
            <a onClick={(e) => this.handleOnClick(e, user.titrationTestingOnly === false, this.toggleTitrationTestModeClickMenuItem)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.tritration'/>}
                              dataKey='titrationTestingOnly'
                              key='titrationTestingOnly'
                              onChange={this.toggleTitrationTestMode}
                              value={user.titrationTestingOnly}/>
            </a>
            <a onClick={(e) => this.handleOnClick(e, user.titrationTestingOnly === true, this.toggleTitrationTestModeClickMenuItem)}>
              <LayoutCheckbox label={<FormattedMessage id='navbar.connected.test.device'/>}
                              dataKey='notTitrationTestingOnly'
                              key='notTitrationTestingOnly'
                              onChange={this.toggleTitrationTestMode}
                              value={!user.titrationTestingOnly}/>
            </a>
          </div>
          <div className='welcome-menu-item'>
            <a href='#'
               onClick={this.logout}
               data-event-category='User'
               data-event-action='signout'>
              <i className='fa fa-sign-out fa-lg'/>
              <span className='single-label'><FormattedMessage id="navbar.logout"/></span>
            </a>
          </div>
        </div>
      </div>;
    }

    let branches = session.getMyBranches();

    let branchKeys = branches.map(x => x.id);
    let branchValues = branches.map(x => x.name);

    branchKeys.unshift('');
    branchValues.unshift('Select a Store'); // TODO: i18n

    return <nav id='nav-bar'
                className='hidden-print'>
      <div className='navbar-header'>
        <a className='navbar-brand'
           href='#'>
          <img src='Content/img/logo.png'
               alt='Alex Logo'
               height='62'
               className='navbar-logo'/>
        </a>
      </div>
      <div className='nav-bar-margin-offset'>
        <div className='container'>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#me'
                 onClick={this.accountOptionsShow}>
                <i className='icon bl bl-profile'/>
                &nbsp;&nbsp;
                <FormattedMessage id="navbar.welcome"/> {user.downgraded ?
                  <FormattedMessage id="navbar.test.station.user"/> :
                this.props.user.name}
                &nbsp;&nbsp;
                <i id='logout-dropdownleft'
                   className='bl bl-dropdown'/>
              </a>
            </li>
            <li>
              <div id='app-select'
                   className='app-select-margins'/>
            </li>
            <li>
              <HeaderAlerts/>
            </li>
            <li>
              <Forecast/>
            </li>
          </ul>
          {accountOptions}
        </div>
      </div>
      {this.state.showBranchesModal ? <Modal onClose={this.closeBranchModal}>
        <div>
          <h2><FormattedMessage id="navbar.select.store.location"/>:</h2>
          <LayoutSelect keys={branchKeys}
                        options={branchValues}
                        editMode={true}
                        label='Stores'
                        dataKey='branchSelect'
                        dataChanged={this.selectBranch}
                        value={this.state.selectedBranch}/>
          <button onClick={this.downgradeToBranch(this.state.selectedBranch)}
                  className='btn btn-primary'
                  disabled={!this.state.selectedBranch}>
            <FormattedMessage id="general.downgrade"/>
          </button>
        </div>
      </Modal> : null}
    </nav>;
  }
}

export default injectIntl(NavBar);
